// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3t8Yg","loaderOuter":"PageOverlayLoader_loaderOuter__2Q8fs"};